// Load global CSS
import React from 'react'
import { ThemeProvider } from './src/components/ThemeProvider'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './src/lib/queryClient'

import './src/styles/global.css'

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <QueryClientProvider client={queryClient}>
      {element}
    </QueryClientProvider>
  </ThemeProvider>
);
